import { runpod_permission } from "./runpod.permission";
import { survey_permission } from "./survey.permission";

export const soul_permission = {
    required_permission: ["use_soul"].concat(survey_permission.required_permission),
    runpod_permission: runpod_permission?.required_permission,
    learning_path_permission: ["view_impactnarrative", "view_response"]
}